<template>
  <span
    class="material-cover"
    :class="{ 'material-cover--artwork': artwork }"
    :style="artwork ? { '--cover-image': `url(&quot;${src}&quot;)` } : null"
  >
    <img :src="src" :alt="alt" loading="lazy">
  </span>
</template>

<script>
// 素材封面铺满父容器（父容器需定位）。播客是方形节目图，完整居中显示，两侧用同一张图的模糊放大版补满
export default {
  name: 'MaterialCover',
  props: {
    src: { type: String, default: '' },
    alt: { type: String, default: '' },
    artwork: { type: Boolean, default: false }
  }
}
</script>

<style scoped>
.material-cover {
  position: absolute;
  inset: 0;
  display: block;
  overflow: hidden;
}

.material-cover img {
  position: relative;
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.material-cover--artwork::before {
  content: '';
  position: absolute;
  inset: 0;
  background: var(--cover-image) center / cover no-repeat;
  filter: blur(24px);
  transform: scale(1.2);
  opacity: 0.85;
}

.material-cover--artwork img {
  object-fit: contain;
}
</style>
